import {
  PackageDepartmentEnum,
  PackageServiceTypeEnum,
} from "@/__generated__/graphql";

export type BetaServiceName =
  | "handyman"
  | "babysitter"
  | "deep-cleaning"
  | "plumbing"
  | "electrician"
  | "pet-sitting"
  | "repair-diagnostic"
  | "maid-agency"
  | "medical-escort"
  | "floor-polishing"
  | "facial"
  | "pest-control"
  | "confinement-nanny";

export const isAirconService = (name: string) => {
  const services = [
    "general-servicing",
    "chemical-overhaul",
    "compressor-wash",
    "gas-top-up",
    "chemical-wash",
    "aircon-service",
  ];
  return services.includes(name);
};

export type AirconServiceName =
  | "general-servicing"
  | "chemical-wash"
  | "compressor-wash"
  | "gas-top-up"
  | "chemical-overhaul";

export type ServiceName =
  | "home-cleaning"
  | "aircon-service"
  | "home-beauty"
  | "home-massage"
  | "pet-grooming"
  | "pet-sitting"
  | "lashes"
  | "elder-care"
  | "deep-cleaning"
  // still un hold pending on vertical lead babysitter
  // | "babysitter"
  | UpholsteryServiceName;

export type UpholsteryServiceName =
  | "mattress-cleaning"
  | "sofa-cleaning"
  | "rug-cleaning"
  | "curtain-cleaning"
  | "pram-seat";

export const UpholsteryServiceNames: UpholsteryServiceName[] = [
  "mattress-cleaning",
  "sofa-cleaning",
  "rug-cleaning",
  "curtain-cleaning",
  "pram-seat",
];

export const OnlineBookingDepartments: PackageDepartmentEnum[] = [
  PackageDepartmentEnum.HomeCleaning,
  PackageDepartmentEnum.Aircon,
  PackageDepartmentEnum.CarpetUpholstery,
  PackageDepartmentEnum.HomeBeauty,
];

export const OfflineBookingServiceTypes: PackageServiceTypeEnum[] = [
  PackageServiceTypeEnum.DeepCleaning,
];
